import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Menu } from 'src/app/interfaces/menu.interface';
import { WpapiService } from 'src/app/services/wpapi.service';
import Player from '@vimeo/player';
import { fadeAnimation } from 'src/app/animations/animation';
import { Router } from '@angular/router';
import { PageService } from 'src/app/services/page.service';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    animations: [fadeAnimation]
})
export class FooterComponent implements OnInit {
    preloadsocials: Menu[] = [];
    preloadmenus: Menu[] = [];
    socials: Menu[] = [];
    menus: Menu[] = [];
    footer: any;
    year: number;
    animateContent: boolean = false;
    iframeIsLoaded: boolean = false;
    videoprogress: number = 0;
    videourl: any;
    player: Player;
    notScrolled: boolean = false;
    scrolled: boolean = false;
    @ViewChild('videoplayer') videoplayer: ElementRef;
    dangerousUrl: any;
    fadeContent: boolean = false;
    fadeContentMenus: boolean = false;
    fadeContentSocials: boolean = false;
    fadeContentLink: boolean = false;
    fadeContentLinkS: boolean = false;
    fadeContentCopyright: boolean = false;
    screenWidth: number = 0;
    isFullPageCompany: boolean = false;
    isFullPageReel: boolean = false;
    activePage;
    whiteLogo: boolean = false;

    constructor(private wpApi: WpapiService,
        private sanitizer: DomSanitizer,
        private router: Router,
        private pageService: PageService) {
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
    }

    ngOnInit(): void {
        this.screenWidth = window.innerWidth;
        this.year = new Date().getFullYear();
        this.getItems();
        this.getFooter();
        if (window.location.pathname == '/company') {
            this.isFullPageCompany = true;
            this.isFullPageReel = false;
        } else if (window.location.pathname == '/reels') {
            this.isFullPageReel = true;
            this.isFullPageCompany = false;
        } else {
            this.isFullPageCompany = false;
            this.isFullPageReel = false;
        }
        if (window.location.pathname == '/') {
            this.activePage = "home";
        } else if (window.location.pathname == '/works' || (this.router.url.indexOf('/works/') > -1)) {
            this.activePage = "work";
        } else {
            this.activePage = window.location.pathname.replace('/', '');
        }
    }

    getItems() {
        this.wpApi.getSocialMenu().subscribe(resp => {
            this.handleSocialResp(resp);
        });
        this.wpApi.getMainMenu().subscribe(resp => {
            this.handleMainResp(resp);
        });
    }

    handleSocialResp(resp) {
        this.socials = resp.items;
    }

    handleMainResp(resp) {
        this.menus = resp.items;
    }

    handleRouterLink(url) {
        const urlreplaced = url.replace('http://', '').replace('https://', '');
        this.router.navigate([urlreplaced]);
    }

    getFooter() {
        this.wpApi.getFooter().subscribe(resp => {
            this.handleFooter(resp);
        });
    }

    handleFooter(resp) {
        this.footer = resp[0].acf;
    }

    goToTop() {
        if (this.screenWidth > 1024) {
            this.pageService.goToTop();
        } else {
            // if(window.location.pathname.includes('work') ){
            //     const grid =  document.getElementById('scroll-grid');
            //     grid.scrollTo ({ 
            //         top:0,
            //         behavior: 'smooth' 
            //     });
            // } else if(window.location.pathname == '/'){
            //     const element = document.querySelector('#main-grid');
            //     element.scrollIntoView({behavior: "smooth"});
            // } else {
            //     this.pageService.goToTop();
            // }
            var element;
            if (window.location.pathname === '/company') {
                element = document.querySelector('#compnay-container-0');
            } else if (window.location.pathname === '/reels') {
                element = document.querySelector('#reel-container-0');
            } else {
                element = document.querySelector('body');
            }
            element.scrollIntoView({ behavior: "smooth" });
        }
    }

    public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
        if (visible) {
            if (this.screenWidth > 1024) {
                this.fadeContent = true;
                setTimeout(() => {
                    this.fadeContentMenus = true;
                    var items = document.getElementsByClassName("footer-menu-links");
                    for (let i = 0; i < items.length; ++i) {
                        fadeIn(items[i], i * 80);
                    }
                }, 200);

                setTimeout(() => {
                    this.fadeContentSocials = true;
                    var items = document.getElementsByClassName("address-link");
                    for (let i = 0; i < items.length; ++i) {
                        fadeIn(items[i], i * 80);
                    }
                }, 400);

                setTimeout(() => {
                    this.fadeContentLink = true;
                    var items = document.getElementsByClassName("footer-menu-socials-links");
                    for (let i = 0; i < items.length; ++i) {
                        fadeIn(items[i], i * 80);
                    }
                }, 600);
            }
            if (this.screenWidth <= 1024) {
                setTimeout(() => {
                    this.fadeContent = true;
                }, 200);
                setTimeout(() => {
                    this.fadeContentLink = true;
                    var items = document.getElementsByClassName("address-link");
                    for (let i = 0; i < items.length; ++i) {
                        fadeIn(items[i], i * 80);
                    }
                }, 300);
                setTimeout(() => {
                    this.fadeContentSocials = true;
                    var items = document.getElementsByClassName("footer-menu-socials-links");
                    for (let i = 0; i < items.length; ++i) {
                        fadeIn(items[i], i * 80);
                    }
                }, 600);
                setTimeout(() => {
                    this.fadeContentCopyright = true;
                }, 1000);
            }

            function fadeIn(item, delay) {
                setTimeout(() => {
                    item.classList.add('fadein')
                }, delay)
            }
        }
    }
}
